export function saveCredentials(json: any) {
    (window as any).savecredentials?.postMessage(json)
}

export function getCredentials() {
    (window as any).getcredentials?.postMessage("")
}